<template>
  <div class="cash-payment split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />
        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" md="10" class="px-4">
              <v-card
                class="pa-5"
                color=" lighten-4"
                flat
                style="border-radius: 15px"
              >
                <div class="mb-3">
                  <h2 class="primary--text today-medium">
                    ¡Tu referencia de pago ha sido generada con éxito!
                  </h2>
                </div>
                <p
                  class="today-light mb-4 text-justify"
                  style="
                    font-size: 1rem;
                    color: rgba(0, 0, 0, 0.8);
                    line-height: 1.5;
                  "
                >
                  Realiza el pago antes de la fecha límite y dentro del horario
                  de atención de la entidad bancaria para garantizar su correcta
                  validación. Hemos enviado todos los detalles a tu correo:
                  <span class="today-medium primary--text">{{ email }}</span>
                </p>

                <v-row justify="start" class="px-4 mt-8">
                  <v-col cols="12" class="pt-3 pl-0 border-b mb-3">
                    <h3
                      class="primary--text today-medium"
                      style="font-size: 0.95rem; font-weight: 600"
                    >
                      DETALLES DE PAGO
                    </h3>
                  </v-col>

                  <v-col cols="12" class="pt-1">
                    <v-row class="border-b">
                      <v-col
                        cols="4"
                        class="today-light pl-0"
                        style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.8)"
                      >
                        Nro de convenio:
                      </v-col>
                      <v-col
                        cols="8"
                        class="today-medium primary--text"
                        style="font-size: 0.875rem"
                      >
                        01583038
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="pt-1">
                    <v-row class="border-b">
                      <v-col
                        cols="4"
                        class="today-light pl-0"
                        style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.8)"
                      >
                        Referencia de pago:
                      </v-col>
                      <v-col
                        cols="8"
                        class="today-medium primary--text"
                        style="font-size: 0.875rem"
                      >
                        {{ paymentReference.payment_reference }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="pt-1">
                    <v-row class="border-b">
                      <v-col
                        cols="4"
                        class="today-light pl-0"
                        style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.8)"
                      >
                        Fecha límite de pago:
                      </v-col>
                      <v-col
                        cols="8"
                        class="today-medium primary--text"
                        style="font-size: 0.875rem"
                      >
                        {{ formatDateCo(paymentReference.payment_limit) }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="pt-1">
                    <v-row class="border-b">
                      <v-col
                        cols="4"
                        class="today-light pl-0"
                        style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.8)"
                      >
                        Monto a pagar:
                      </v-col>
                      <v-col
                        cols="8"
                        class="today-medium primary--text"
                        style="font-size: 0.875rem"
                      >
                        {{ formatCurrency(paymentReference.payment_amount) }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="py-1">
                    <v-row>
                      <v-col
                        cols="4"
                        class="today-light pl-0"
                        style="font-size: 0.875rem; color: rgba(0, 0, 0, 0.8)"
                      >
                        Entidad financiera:
                      </v-col>
                      <v-col
                        cols="8"
                        class="today-medium primary--text"
                        style="font-size: 0.875rem"
                      >
                        BANCO DAVIVIENDA
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="text-center mt-16">
                    <v-btn
                      style="min-width: 240px"
                      :loading="loading"
                      :disabled="loading"
                      @click="goHome"
                      color="primary"
                      class="px-12 text-capitalize vardi-button white--text"
                      elevation="0"
                      rounded
                    >
                      FINALIZAR
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage.vue";
import NavBarPage from "@/components/Layouts/NavBarPage.vue";
import { formatCurrency, formatDateCo } from "@/helpers/constants";

export default {
  name: "CashPayment",
  components: { NavBarPage, LeftSideImage },
  data() {
    return {
      paymentReference: null,
      loading: false,
      snackbar: false,
      timeout: 3000,
      messageSnackbar: "",
      email: null,
    };
  },
  created() {
    this.paymentReference = JSON.parse(
      localStorage.getItem("payment_reference")
    );
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user);
    this.email = user.email;
  },
  mounted() {},
  methods: {
    goHome() {
      localStorage.clear();
      this.$router.push("/");
    },
    formatCurrency: formatCurrency,
    formatDateCo: formatDateCo,
  },
};
</script>
<style lang="scss">
.v-card {
  box-shadow: none !important;
}

.border-b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0 !important;
}
</style>
